// extracted by css-extract-rspack-plugin
export default {"expirationOptions":"mvfPM9XQGwnqPqnp"};